"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _basicCardStyleTypes = require("./basicCardStyleTypes");

var defaultProps = {
  componentName: "basicCard",
  cms: {
    style: {
      bottomSpace: "Title bottom space",
      imageRadius: "Image Shape",
      contentAlign: "Content position"
    },
    links: {
      link1: "Title",
      url1: "url 1",
      link2: "Title",
      url2: "Url 2"
    },
    content: {
      title: "Title",
      paragraph: "Content",
      link1: "Button link title",
      url1: "Button url",
      link2: "Link title",
      url2: "link url"
    },
    media: {
      imgUrl: "Image url",
      alt: "Atl text *"
    }
  },

  styleType: {
    style: {
      bottomSpace: { type: "textField" },
      imageRadius: { type: "textField" },
      contentAlign: _extends({}, _basicCardStyleTypes.contentAlign)
    }
  },
  props: {
    style: {
      bottomSpace: "20",
      imageRadius: "5",
      contentAlign: "center"
    },
    links: {
      link1: "Add Product",
      url1: "",
      link2: "learn more",
      url2: "/"
    },
    content: {
      title: "<span>Title</span>",
      paragraph: "<span>Lorem Ipsum is simply dummy text of the printing and typesetting industry typesetting industry text of the printing and typesetting industry. </span>"
    },
    media: {
      imgUrl: "https://ik.imagekit.io/marketcube/platform/storybook/mc.jpg",
      alt: "alt text"
    }
  }
};
exports.default = defaultProps;